import { Box, Typography, Stack, Paper } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import MessageInput from '../chat/MessageInput';

const suggestions = [
  'Explain health insurance basics',
  'What documents are needed for claims?',
  'Compare term vs health insurance',
  'How does cashless hospitalization work?'
];

export default function EmptyState({ onSelect, input, onInputChange, onSend }) {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <Stack
        spacing={4}
        alignItems="center"
        sx={{
          width: '100%',
          maxWidth: 760,
          minHeight: '100%',
          justifyContent: 'center',
          textAlign: 'center'
        }}
      >
        {/* Logo / Icon */}
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            backgroundColor: 'primary.light',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 28
          }}
        >
          <AutoAwesomeIcon color="primary" />
        </Box>

        {/* Title */}
        <Typography variant="h4" fontWeight={600} textAlign="center">
          Ready when you are.
        </Typography>

        {/* Subtitle */}
        <Typography variant="body1" color="text.secondary" textAlign="center" sx={{ maxWidth: 520 }}>
          Ask anything about insurance, claims, policies, or coverage.
        </Typography>
        <MessageInput value={input} onChange={onInputChange} onSend={onSend} center />

        {/* Suggestions */}
        <Stack spacing={2} width="100%">
          {suggestions.map((text, index) => (
            <Paper
              key={index}
              variant="outlined"
              onClick={() => onSelect(text)}
              sx={{
                p: 2.2,
                cursor: 'pointer',
                borderRadius: 2,
                fontSize: '0.95rem',
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: 'primary.main',
                  backgroundColor: 'rgba(0,0,0,0.03)'
                }
              }}
            >
              <Typography fontSize={14}>{text}</Typography>
            </Paper>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
}
